import { axios, withPartialContent } from 'shared/services/axios'

export const createSnapshotUrl = withPartialContent(
  ({ contentItemId, guid = null }) => {
    return axios.post(`/live_board/v1/content_items/${contentItemId}/snapshots`,{
      guid
  })
})

export function analyzeUrl({contentItemId}) {
  return axios.post(`/live_board/v1/content_items/${contentItemId}/analyses`)
}

export const getFileMetadata = withPartialContent(({ contentItemId }) => {
  return axios.get(`/live_board/v1/content_items/${contentItemId}/files`)
})